/**
 * @file SectionTextField.tsx
 * @description Текстовое поле секции (phase19.16 Р2): поле вида сайта
 * (`TextField` со счётчиком «11/40») плюс замечание проверки по пути и
 * жёлтые предупреждения о тексте (§16.6) под ним.
 */

import { TextField } from "../../../site-view/TextField";
import { useSectionForm } from "../section-form-context";
import { warningMessage } from "../../../../lib/site-builder/text-warnings";

interface Props {
  label: string;
  /** Путь поля в payload — по нему находятся замечания и предупреждения. */
  path: string;
  value: string | undefined;
  onChange: (value: string) => void;
  max: number;
  multiline?: boolean;
  hint?: string;
  placeholder?: string;
}

export function SectionTextField({ label, path, value, onChange, max, multiline, hint, placeholder }: Props) {
  const form = useSectionForm();
  const warnings = form.warningsAt(path);
  return (
    <div className="flex flex-col gap-1">
      <TextField label={label} value={value ?? ""} onChange={onChange} max={max} multiline={multiline} hint={hint} placeholder={placeholder} error={form.issueAt(path)} />
      {warnings.map((w) => (
        <p key={`${w.kind}-${w.term}`} role="note" className="type-caption rounded-md border-l-4 border-warning bg-warning/10 px-2 py-1 text-on-surface">
          {warningMessage(w)}
        </p>
      ))}
    </div>
  );
}
